import React from "react";

const Categories = (props) => {
  const { categories, id, name, icon, onSelectCategory, selectedCategory } =
    props;
  return (
    <>
      <img
        src={`/documents/d/surekhatech/${icon}`}
        alt={name}
        width="30"
        height="30"
        loading="lazy"
        className="st-category-icon"
      />
      <select
        name="select"
        id={id}
        className="st-category-select text-left"
        value={selectedCategory}
        onChange={(e) => onSelectCategory(e.target.id, e.target.value, id)}
      >
        <option value="">Search by {name}</option>
        {categories.map((cat) => (
          <option key={cat.id} value={cat.id}>
            {cat.name}
          </option>
        ))}
      </select>
      <img
        src="/documents/d/surekhatech/down-arrow"
        alt="select-arrow"
        className="st-select-drop-arrow"
        width="14"
        height="8"
        loading="lazy"
      />
    </>
  );
};

export default Categories;
